import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiEmojiButtonComponent } from './fi-emoji-button.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiEmojiImageDirective } from './fi-emoji-image.directive';

@NgModule({
    imports: [CommonModule, PickerModule, MatButtonModule, MatIconModule, FiAppTextSharedModule, FiLoadingModule],
    declarations: [FiEmojiButtonComponent, FiEmojiImageDirective],
    exports: [FiEmojiButtonComponent, FiEmojiImageDirective],
})
export class FiEmojiModule {}
